import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, Switch, theme } from 'antd';
import { PosFormItem } from 'pos-client/components/shared/Form/PosFormItem.tsx';
import { PosInput } from 'pos-client/components/shared/Form/PosInput.tsx';
import { PosSelect } from 'pos-client/components/shared/Form/PosSelect.tsx';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';

const rechargePolicyOptions = [
  {
    value: 'AnyDepot',
    key: 'AnyDepot',
  },
  {
    value: 'InitialDepot',
    key: 'InitialDepot',
  },
  {
    value: 'FinalDepot',
    key: 'FinalDepot',
  },
  {
    value: 'InitialOrFinal',
    key: 'InitialOrFinal',
  },
];

interface RechargeSettingsProps {
  control: Control<RMAssetFormType>;
}

const RechargeSettingsTabContent = ({ control }: RechargeSettingsProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  return (
    <>
      <Row gutter={[token.marginXL, token.marginXL]}>
        <Col span={12}>
          <PosFormItem
            label={t('routes.rechargeSettings.allowRecharges')}
            name="rechargeSettings.allowRecharges"
            control={control}
          >
            <Switch disabled />
          </PosFormItem>
        </Col>
        <Col span={12}>
          <PosSelect
            control={control}
            label={t('routes.rechargeSettings.rechargePolicy')}
            name="rechargeSettings.rechargePolicy"
            options={rechargePolicyOptions}
            disabled
          />
        </Col>
      </Row>
      <Row gutter={[token.marginXL, token.marginXL]}>
        <Col span={12}>
          <PosFormItem
            label={t('routes.rechargeSettings.rechargeToCapacity')}
            name="rechargeSettings.rechargeToCapacity"
            control={control}
          >
            <Switch disabled />
          </PosFormItem>
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('routes.rechargeSettings.maxDistance')}
            name="maxDistance"
            readOnly
          />
        </Col>
      </Row>
    </>
  );
};

export default RechargeSettingsTabContent;
